// authSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

//* Define the shape of the AuthState
interface AuthState {
  userToken: any;
  refreshToken: any;
  loggedIn: boolean;
  userInfo: any;
  isNewUser: boolean;
  matchedUser: any[];
  loggedInUser: {};
  isFirstLaunch: boolean;
  location: any;
  expoDeviceToken: string;
  inAppNotification:any
}

//* Set the initial state for the auth slice
const initialState: AuthState = {
  userToken: null,
  refreshToken: null,
  loggedIn: false,
  userInfo: null,
  isNewUser: false,
  matchedUser: [],
  loggedInUser: "",
  isFirstLaunch: true,
  location: '',
  expoDeviceToken: '',
  inAppNotification:null
};

//* Create a slice using createSlice
const authSlice = createSlice({
  name: "auth", //* The name of the slice
  initialState, //* The initial state
  reducers: {
    //* Define a reducer to handle the setAuthenticated action
    setLoggedIn: (state, action: PayloadAction<any>) => {
      state.loggedIn = true;
      state.userToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
      state.isNewUser = true;
    },
    setLoggedOut: (state) => ({
      ...initialState, 
      isFirstLaunch: state.isFirstLaunch,
    }),
    setNewUser: (state) => {
      state.isNewUser = false;
    },
    setUserToken: (state, action: PayloadAction<any>) => {
      state.userToken = action.payload;
    },
    setFirstLaunch: (state) => {
      state.isFirstLaunch = false
    },
    addMatchedUser: (state, action: PayloadAction<any>) => {
      const newUsers = action.payload.map((item: any) => item.data);
      state.matchedUser = [];

      const uniqueUserIds = new Set(state.matchedUser.map((user) => user.id));
      const filteredNewUsers = newUsers.filter(
        (user: any) => !uniqueUserIds.has(user.id)
      );
      state.matchedUser = [...state.matchedUser, ...filteredNewUsers];
    },
    setLocation: (state, action: PayloadAction<any>) => {
      state.location = action.payload
    },
    setExpoToken:(state,action:PayloadAction<any>) =>{
      state.expoDeviceToken = action.payload
    },
    setUserInfo:(state,action:PayloadAction<any>)=>{
      console.log(action.payload,"user id")
      state.userInfo=action.payload
    },
    setInAppNotification:(state,action:PayloadAction<any>)=>{
      state.inAppNotification=action.payload
    }
  },
});

//* Extract the action creator(s) and reducer from the slice
export const { 
  setLoggedIn, 
  setLoggedOut, 
  addMatchedUser, 
  setNewUser, 
  setUserToken, 
  setFirstLaunch, 
  setLocation, 
  setExpoToken,
  setUserInfo,
  setInAppNotification
} = authSlice.actions;

//* Export the entire slice, which includes the reducer
export default authSlice.reducer;
export const selectMatchedUsers = (state: RootState) => state.user.matchedUser;
export const selectUserToken = (state: RootState) => state.user.userToken;
export const selectUserInfo = (state:RootState) => state.user.userInfo
export const selectLoggedUserDeviceToken = (state:RootState) => state.user.expoDeviceToken
export const selectInAppNotification = (state:RootState) => state.user.inAppNotification